import {useState} from "react"
import {ApplicationDocumentSide} from "../resources/application"
import {RotationDegrees} from "../utilities/imageOrientation"

export interface Zoom {
	val: number
	zoomIn: () => void
	zoomOut: () => void
}
export interface Rotation {
	val: RotationDegrees
	changeRotation: () => void
	setRotation: (deg: RotationDegrees) => void
}

interface ActiveDocumentSide {
	val: ApplicationDocumentSide
	toggleActiveSide: () => void
}

interface Toolbar {
	zoom: Zoom
	rotation: Rotation
	activeDocumentSide: ActiveDocumentSide
}

const defaultZoomValue = 1

export function useToolbar(side: ApplicationDocumentSide): Toolbar {
	const [degree, setDegree] = useState<RotationDegrees>(0)
	const [zoom, setZoom] = useState(defaultZoomValue)
	const [docActiveSide, setDocActiveSide] = useState(side)

	const changeRotation = () => {
		switch (degree) {
			case 0:
				setDegree(90)
				break
			case 90:
				setDegree(180)
				break
			case 180:
				setDegree(270)
				break
			default:
				setDegree(0)
				break
		}
	}

	const toggleActiveSide = () => {
		docActiveSide === ApplicationDocumentSide.Front
			? setDocActiveSide(ApplicationDocumentSide.Back)
			: setDocActiveSide(ApplicationDocumentSide.Front)

		setDegree(0)
	}

	const zoomIn = () => setZoom(zoom + 0.25)
	const zoomOut = () => setZoom(zoom - 0.25)

	return {
		zoom: {
			val: zoom,
			zoomIn,
			zoomOut,
		},
		rotation: {
			val: degree,
			changeRotation,
			setRotation: setDegree,
		},
		activeDocumentSide: {
			val: docActiveSide,
			toggleActiveSide,
		},
	}
}
